$(function() {
	$('button#cancel', '#research').click(function() {
		window.history.back();
	});
	$('input.headline', '#research').first().focus();
	$('.thumbnail', '#research').hover(function() {
		$('.delete', this).toggle();
	});
	$('.delete', '#research').hover(function() {
		$(this).siblings('a').toggleClass('hover');
	});
	$('#reserach_search_form').bind('submit', function(e) {
		e.preventDefault();
		var $this = $(this);
		var serialized = $this.serialize();
		var $results = $('#reserach_search_results');
		var url = $results.data('url');
		$.get(url, serialized, function(d) {
			$results.html(d);
		});
		history.pushState(null, null,'?' + serialized);
	});

	$('document').ready(function(){
		var searchOnload = false;
		$('#reserach_search_form').find('select, input[type=text]').each(function() {
			var val = $(this).val().toString();
			if (val && val !== '-1') {
				searchOnload = true;
			}
		});
		if (searchOnload) {
			$('#reserach_search_form').trigger('submit');
		}
	});
});
